/* Member vouchers in the cart (markup + first paint: snippets/ar-vouchers.liquid, mode 'cart').
   RM50 member vouchers (ARJ… join, ARS/ARG/ARV tier codes, ARC-… from AR Credit top-ups): one RM50 voucher per RM150 of
   items at their ORIGINAL price (owner 10/28: before Mix & Match and before any voucher): n = floor(original / RM150) →
   RM150 → 1, RM300 → 2, RM450 → 3, and so on. In Shopify every voucher
   (RM50, RM15, birthday, comeback, referral) is an order discount that stacks with the others and with Mix & Match;
   Shopify itself only checks "this order is RM150+", so this limit is kept here and extra RM50 codes are taken off.
   RM15 review thank-you (ARR15-…): one per review, created by Shopify Flow for that customer only and listed on the
   account as a customer tag "r15:CODE:YYYYMMDD". One per order, no minimum spend, stacks with the RM50 voucher.
   Both are applied automatically through /cart/update.js (discount = comma-separated codes) when the cart qualifies;
   Remove takes one off and keeps it off for this cart. If the cart drops under RM150 the RM50 voucher is taken off again.
   Guests get the join code too (first-order price without signing up; Shopify allows one use per customer/email, customers with no orders only).
   11.11 (card .ar-sale from snippets/ar-vouchers.liquid, only on 1–12 Nov): Shopify automatic discounts, see saleStep below. */
(() => {
  if (window.arVouchers) return;
  window.arVouchers = true;

  const VOUCHER = /^AR(?:[JSGV]\d+|C)-[A-Z0-9]+$/i;
  const R15 = /^ARR15-[A-Z0-9]+$/i;
  // birthday (ARB<yy>-20/30/50/80) and comeback (ARRB-20) gifts: applied once each, never on an AR Credit top-up
  const GIFT = /^AR(?:B\d{2}-\d+|RB-20)$/i;
  const zh = () => (document.documentElement.lang || '').toLowerCase().startsWith('zh');
  const ms = () => (document.documentElement.lang || '').toLowerCase().startsWith('ms');
  const t = (en, cn, my) => (zh() ? cn : ms() && my ? my : en);
  const split = (s) => (s || '').split(',').filter(Boolean);

  const DECLINED = 'ar-vch-declined';
  const DECLINED_R = 'ar-r15-declined';
  // Remove keeps the voucher off for this cart as it is; once the items change, the best price is applied again
  const isDeclined = (key, cart) => { try { return sessionStorage.getItem(key) === `${cart.token}|${cart.items_subtotal_price}`; } catch (e) { return false; } };
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const setCodes = (codes) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
  // one auto try per cart + subtotal within 6s, so a code Shopify refuses can't cause a reload loop
  const tried = (key, autoKey) => {
    try {
      const [k, at] = (sessionStorage.getItem(key) || '').split('#');
      return k === autoKey && Date.now() - Number(at) < 6000;
    } catch (e) { return true; }
  };
  // a code Shopify kept off is remembered for 2 minutes only, so it comes back if the cart or the offer changes
  const refused = (key, cart) => {
    try {
      const [sub, at] = (sessionStorage.getItem(key) || '').split('|');
      return sub === String(cart.items_subtotal_price) && Date.now() - Number(at) < 120000;
    } catch (e) { return false; }
  };

  let refreshing = false;
  async function refresh() {
    refreshing = true;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
      const sections = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`).then((r) => r.json());
      drawer.renderContents({ sections });
    } else {
      window.location.reload();
    }
  }

  async function render(el) {
    el.dataset.arVchDone = '1';
    const codes = split(el.dataset.arVch);
    const r15 = split(el.dataset.arR15);
    const gifts = split(el.dataset.arGift);
    if (!codes.length && !r15.length && !gifts.length) return;
    const cart = await getCart();
    // an emptied cart starts over: forget earlier tries, refusals and a Remove, so the next items get the voucher again
    if (!cart.item_count) {
      try { ['ar-vch-auto', 'arVchNo', DECLINED, 'ar-r15-auto', 'arR15No', DECLINED_R].forEach((k) => sessionStorage.removeItem(k)); } catch (e) {}
    }
    const all = cart.discount_codes || [];
    const applied = all.filter((d) => VOUCHER.test(d.code));
    const appliedR = all.filter((d) => R15.test(d.code));
    const others = all.filter((d) => !VOUCHER.test(d.code) && !R15.test(d.code) && !GIFT.test(d.code)).map((d) => d.code);
    const appliedG = all.filter((d) => GIFT.test(d.code));
    const topup = (cart.items || []).filter((i) => i.handle === 'ar-credit-topup').reduce((s, i) => s + (i.final_line_price || 0), 0);
    const okCart = !topup && (cart.items_subtotal_price || 0) > 0;
    const canR = Math.min(okCart ? 1 : 0, r15.length); // RM15 has no minimum spend
    // what the other vouchers take off (RM15, birthday, referral…): all order-level discounts minus the RM50s already on,
    // plus the RM15 that is about to be added
    const orderOff = (cart.cart_level_discount_applications || []).reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
    const otherOff = Math.max(0, orderOff - 5000 * applied.filter((d) => d.applicable).length) + (canR && !appliedR.length ? 1500 : 0);
    // original price of the items (before Mix & Match and any voucher), top-ups never count
    const original = okCart ? (cart.items || []).filter((i) => i.handle !== 'ar-credit-topup').reduce((s, i) => s + (i.original_line_price || 0), 0) : 0;
    void otherOff;
    const per = Math.floor(original / 15000);                                // one RM50 per RM150 at original price
    const can = Math.min(per, codes.length);
    const keepV = applied.slice(0, can).map((d) => d.code);
    const keepR = appliedR.slice(0, canR).map((d) => d.code);

    // gifts: all of them on a normal cart, none on a top-up (or once removed for this cart)
    const giftsOk = okCart && !isDeclined('ar-gift-declined', cart);
    const keepG = giftsOk ? appliedG.filter((d) => d.applicable).map((d) => d.code) : [];
    if (applied.length > can || appliedR.length > canR || keepG.length < appliedG.length) {
      if (appliedG.some((d) => !d.applicable)) try { sessionStorage.setItem('arGiftNo', `${cart.items_subtotal_price}|${Date.now()}`); } catch (e) {}
      await setCodes([...others, ...keepV, ...keepR, ...keepG]);
      return refresh();
    }

    const on = applied.filter((d) => d.applicable).length;
    const onR = appliedR.filter((d) => d.applicable).length;
    if (applied.length && on === 0) {
      // the voucher was added but Shopify did not accept it (e.g. minimum not met after other discounts): take it off again and say why
      try { sessionStorage.setItem('arVchNo', `${cart.items_subtotal_price}|${Date.now()}`); } catch (e) {}
      await setCodes([...others, ...keepR, ...keepG]);
      return refresh();
    }
    if (appliedR.length && onR === 0) {
      try { sessionStorage.setItem('arR15No', `${cart.items_subtotal_price}|${Date.now()}`); } catch (e) {}
      await setCodes([...others, ...keepV, ...keepG]);
      return refresh();
    }
    const blocked = refused('arVchNo', cart);
    const blockedR = refused('arR15No', cart);

    // Auto-apply when the cart qualifies, the code isn't on yet and the customer hasn't removed it
    const autoKey = `${cart.token}|${cart.items_subtotal_price}`;
    const needV = can > applied.length && !blocked && !isDeclined(DECLINED, cart) && !tried('ar-vch-auto', autoKey);
    const needR = canR > 0 && !appliedR.length && !blockedR && !isDeclined(DECLINED_R, cart) && !tried('ar-r15-auto', autoKey);
    const missingG = giftsOk && !refused('arGiftNo', cart) ? gifts.filter((g) => !appliedG.some((d) => d.code.toUpperCase() === g.toUpperCase())) : [];
    const needG = missingG.length > 0 && !tried('ar-gift-auto', autoKey);
    if (needV || needR || needG) {
      try {
        if (needV) sessionStorage.setItem('ar-vch-auto', `${autoKey}#${Date.now()}`);
        if (needR) sessionStorage.setItem('ar-r15-auto', `${autoKey}#${Date.now()}`);
        if (needG) sessionStorage.setItem('ar-gift-auto', `${autoKey}#${Date.now()}`);
      } catch (e) {}
      // top up to one RM50 per RM150 (codes already on stay); other codes and the RM15 stay on
      const want = needV ? [...new Set([...keepV, ...codes.filter((c) => !keepV.some((k) => k.toUpperCase() === c.toUpperCase()))])].slice(0, can) : keepV;
      const list = [...others, ...want, ...keepR, ...keepG];
      if (needR) list.push(r15[0]);
      if (needG) list.push(...missingG);
      await setCodes(list);
      return refresh();
    }

    // guests (snippets/ar-vouchers.liquid, .ar-vch--guest): the server line already says "first order RM50 off" + sign in for the mask; keep it
    if (el.classList.contains('ar-vch--guest')) { el.classList.toggle('ar-vch--used', on > 0); return; }

    let text = '';
    let button = '';
    const used = [];
    if (on > 0) used.push(t(`RM${on * 50} voucher`, `RM${on * 50} 礼券`, `Baucar RM${on * 50}`));
    if (onR > 0) used.push(t('RM15 thank-you', 'RM15 评价礼', 'Hadiah ulasan RM15'));
    if (used.length) {
      const sv = on * 50 + onR * 15;
      text = `<b class="ar-vch__s">${t(`You save RM${sv}`, `已省 RM${sv}`, `Jimat RM${sv}`)} · </b>${used.join(' + ')}`;
      button = `<button type="button" class="ar-vch__b ar-vch__b--ghost" ${on > 0 ? 'data-n="0"' : 'data-r="0"'}>${t('Remove', '取消', 'Buang')}</button>`;
    } else if ((codes.length && blocked) || (!codes.length && blockedR)) {
      text = t('Vouchers can’t be used on this order', '这单用不了礼券', 'Baucar tak boleh digunakan untuk pesanan ini');
    } else if (can > 0 || canR > 0) {
      const avail = [];
      if (can > 0) avail.push(t('RM50 voucher', 'RM50 礼券', 'Baucar RM50'));
      if (canR > 0) avail.push(t('RM15 thank-you', 'RM15 评价礼', 'Hadiah ulasan RM15'));
      const sv = (can > 0 ? 50 : 0) + (canR > 0 ? 15 : 0);
      text = t(`${avail.join(' + ')} · save RM${sv}`, `${avail.join(' + ')} · 可省 RM${sv}`, `${avail.join(' + ')} · jimat RM${sv}`);
      button = `<button type="button" class="ar-vch__b" data-all="1">${avail.length > 1 ? t('Use all', '全部使用', 'Guna semua') : t('Use', '使用', 'Guna')}</button>`;
    } else {
      if (topup) { el.hidden = true; return; }
      const save = 50;
      const sub = original;
      const gap = 15000 - sub;
      const rm = 'RM' + (gap % 100 ? (gap / 100).toFixed(2) : gap / 100);
      text = sub > 0 ? t(`Add <b>${rm}</b> more to save <b>RM${save}</b>`, `再买 <b>${rm}</b>，礼券可省 <b>RM${save}</b>`, `Tambah <b>${rm}</b> lagi untuk jimat <b>RM${save}</b>`) : t(`Spend RM150 to save RM${save} with vouchers`, `满 RM150，礼券可省 RM${save}`, `Belanja RM150 untuk jimat RM${save} dengan baucar`);
    }
    const html = `<p class="ar-vch__t">${text}</p>${button}`;
    // the server already drew the same line: leave it alone so nothing flickers
    if (el.innerHTML.replace(/\s+/g, ' ').trim() !== html.replace(/\s+/g, ' ').trim()) el.innerHTML = html;
    el.classList.toggle('ar-vch--used', on > 0 || onR > 0);
    el._codes = codes;
    el._r15 = r15;
    el._others = [...others, ...keepR];
    el._cart = all.map((d) => d.code);
    el.hidden = false;
  }

  // ---- 11.11 ----
  // Shopify automatic discounts (titles start "11.11"): RM111 off at RM388+, RM222 off at RM688+ (original price), no code,
  // no limit per customer; stacks with RM50 / RM15 / other vouchers (owner 10/30), not with Mix & Match (Shopify keeps the bigger one). This card only
  // says what is on and what the next step is; tiers come from the card as min:off in sen.
  // Shopify spreads an automatic order discount over the lines, so it is read from each line's allocations
  const saleAllocs = (cart) => (cart.items || []).flatMap((i) => (i.line_level_discount_allocations || []).filter((a) => /^11\.11/.test((a.discount_application || {}).title || '')));
  const saleOn = (cart) => saleAllocs(cart).length > 0;
  const rm = (sen) => 'RM' + (sen % 100 ? (sen / 100).toFixed(2) : sen / 100);

  async function saleStep() {
    // the cart page and the (closed) drawer both carry the card: draw every copy
    const boxes = [...document.querySelectorAll('.ar-sale')];
    if (!boxes.length) return;
    const tiers = split(boxes[0].dataset.arSale).map((x) => { const [min, off] = x.split(':').map(Number); return { min, off }; }).sort((a, b) => a.min - b.min);
    const cart = await getCart();
    const topup = (cart.items || []).some((i) => i.handle === 'ar-credit-topup');
    const orig = topup ? 0 : (cart.items || []).reduce((s, i) => s + (i.original_line_price || 0), 0);
    const hide = () => boxes.forEach((box) => { box.hidden = true; });
    if (!cart.item_count || topup || !tiers.length) return hide();
    const next = tiers.find((x) => orig < x.min);
    let html;
    if (saleOn(cart)) {
      // vouchers Shopify set aside for the 11.11 discount: take them off so checkout shows no "can't be combined" note
      const codes = cart.discount_codes || [];
      if (codes.some((d) => !d.applicable) && !tried('ar-sale-clean', `${cart.token}|${orig}`)) {
        try { sessionStorage.setItem('ar-sale-clean', `${cart.token}|${orig}#${Date.now()}`); } catch (e) {}
        await setCodes(codes.filter((d) => d.applicable).map((d) => d.code));
        return refresh();
      }
      const off = saleAllocs(cart).reduce((s, a) => s + (a.amount || 0), 0);
      html = `<p class="ar-vch__t"><b class="ar-vch__s">${t(`You save ${rm(off)}`, `已减 ${rm(off)}`, `Jimat ${rm(off)}`)}</b>${next ? t(` · add <b>${rm(next.min - orig)}</b> more to save <b>${rm(next.off)}</b>`, ` · 再买 <b>${rm(next.min - orig)}</b>，减 <b>${rm(next.off)}</b>`, ` · tambah <b>${rm(next.min - orig)}</b> lagi untuk jimat <b>${rm(next.off)}</b>`) : ''}</p>`;
    } else if (next && next === tiers[0]) {
      html = `<p class="ar-vch__t">${t(`Add <b>${rm(next.min - orig)}</b> more to save <b>${rm(next.off)}</b>`, `再买 <b>${rm(next.min - orig)}</b>，减 <b>${rm(next.off)}</b>`, `Tambah <b>${rm(next.min - orig)}</b> lagi untuk jimat <b>${rm(next.off)}</b>`)}</p>`;
    } else {
      return hide();                             // the usual offers already cost less (e.g. first-order RM50 + Mix & Match): show only those
    }
    boxes.forEach((box) => {
      const line = box.querySelector('.ar-sale__l');
      if (line.innerHTML !== html) line.innerHTML = html;
      line.classList.toggle('ar-vch--used', saleOn(cart));
      box.hidden = false;
    });
  }

  // vouchers first (they may reload the page); once they have settled, the 11.11 step compares and decides
  let scanning = false;
  const scan = async () => {
    if (scanning) return;
    scanning = true;
    refreshing = false;
    try {
      await Promise.all([...document.querySelectorAll('.ar-vch:not([data-ar-vch-done])')].map((el) => render(el).catch(() => {})));
      if (!refreshing) await saleStep().catch(() => {});
    } finally { scanning = false; }
  };

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.ar-vch__b');
    if (!b || !b.closest('.ar-vch')) return;
    const el = b.closest('.ar-vch');
    b.disabled = true;
    if (b.dataset.all) {
      try { sessionStorage.removeItem(DECLINED); sessionStorage.removeItem(DECLINED_R); } catch (err) {}
      const rest = (el._cart || []).filter((c) => !VOUCHER.test(c) && !R15.test(c));
      await setCodes([...rest, ...(el._codes || []).slice(0, 1), ...(el._r15 || []).slice(0, 1)]);
      return refresh();
    }
    if (b.dataset.r !== undefined) {
      // RM15 review thank-you on its own (no RM50 voucher line)
      const r = Number(b.dataset.r) || 0;
      const rest = (el._cart || []).filter((c) => !R15.test(c));
      if (r === 0) {
        try { const c = await getCart(); sessionStorage.setItem(DECLINED_R, `${c.token}|${c.items_subtotal_price}`); } catch (err) {}
      } else {
        try { sessionStorage.removeItem(DECLINED_R); } catch (err) {}
      }
      await setCodes(r ? [...rest, (el._r15 || [])[0]].filter(Boolean) : rest);
      return refresh();
    }
    if (!b.dataset.n) return;
    const n = Number(b.dataset.n) || 0;
    if (n === 0) {
      try { const c = await getCart(); sessionStorage.setItem(DECLINED, `${c.token}|${c.items_subtotal_price}`); } catch (err) {}
    } else {
      try { sessionStorage.removeItem(DECLINED); } catch (err) {}
    }
    await setCodes([...(el._others || []), ...(el._codes || []).slice(0, n)]);
    refresh();
  });

  // only added elements can bring a new voucher box, so text/attribute churn elsewhere never triggers a scan
  const added = (ms) => ms.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1));
  // only the cart containers (the voucher box lives in the drawer footer / cart page footer)
  const mo = new MutationObserver((ms) => { if (added(ms)) scan(); });
  document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer').forEach((t) => mo.observe(t, { childList: true, subtree: true }));
  scan();
})();
